// TODO: 调整位置
import { action, Action } from 'easy-peasy';
import { ImagePanelFeatureType } from '@/types';

export interface IImageAdjustModel {
    /** 当前面板类型 */
    currentType: ImagePanelFeatureType | '';
    /** 设置当前面板类型 */
    setCurrentType: Action<IImageAdjustModel, ImagePanelFeatureType | ''>;
}

// TODO: 当前图片面板里面的消除笔和调色都在使用这个，待确认是否应该拆开
export const imagePanelAdjustModel: IImageAdjustModel = {
    currentType: '',
    setCurrentType: action((state, payload) => {
        state.currentType = payload;
    }),
};
